var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-column" },
    [
      _c(
        "el-form-item",
        {
          staticClass: "flex-column",
          attrs: {
            prop: "phone",
            label: _vm.$t.__("common.labels.phone"),
            error: _vm.error ? _vm.error.tel : ""
          }
        },
        [
          _c("vue-tel-input", {
            staticClass: "span_6",
            attrs: {
              "data-bot": _vm.getDatabot("phone", _vm.currentStore),
              placeholder: "+33",
              type: "tel",
              "default-country": _vm.$store.state.corp.countryCode.toLowerCase()
            },
            model: {
              value: _vm.phone,
              callback: function($$v) {
                _vm.phone = $$v
              },
              expression: "phone"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          staticClass: "flex-column",
          attrs: {
            prop: "mobile",
            label: _vm.$t.__(
              "thirds.thirdscomponents.FormFieldsNumberPhone.mobile_phone"
            ),
            error: _vm.error ? _vm.error.mobile : ""
          }
        },
        [
          _c("vue-tel-input", {
            staticClass: "span_6",
            attrs: {
              "data-bot": _vm.getDatabot("mobile", _vm.currentStore),
              placeholder: "+33",
              type: "tel",
              "default-country": _vm.$store.state.corp.countryCode.toLowerCase()
            },
            model: {
              value: _vm.mobile,
              callback: function($$v) {
                _vm.mobile = $$v
              },
              expression: "mobile"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.faxIsVisible
        ? _c(
            "a",
            {
              staticClass: "mt-2 pointer fs-3 semibold hover-primary-100",
              attrs: {
                "data-bot": _vm.getDatabot("add-fax", _vm.currentStore)
              },
              on: {
                click: function($event) {
                  _vm.faxIsVisible = !_vm.faxIsVisible
                }
              }
            },
            [_vm._v(_vm._s(_vm.$l10n.__("Ajouter un fax")))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.faxIsVisible,
              expression: "faxIsVisible"
            }
          ],
          staticClass: "flex-column",
          attrs: {
            prop: "fax",
            label: _vm.$t.__(
              "thirds.thirdscomponents.FormFieldsNumberPhone.fax"
            ),
            error: _vm.error ? _vm.error.fax : ""
          }
        },
        [
          _c("vue-tel-input", {
            staticClass: "span_6",
            attrs: {
              "data-bot": _vm.getDatabot("fax", _vm.currentStore),
              placeholder: "+33",
              type: "tel",
              "default-country": _vm.$store.state.corp.countryCode.toLowerCase()
            },
            model: {
              value: _vm.fax,
              callback: function($$v) {
                _vm.fax = $$v
              },
              expression: "fax"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }